import Vue from "vue"

import "normalize.css/normalize.css" // A modern alternative to CSS resets

import App from "./App.vue"
import router from "./router"
import store from "./store"
import ElementUI from "element-ui"

//引入 i18n
import i18n from "./language/i18n"

import "element-ui/lib/theme-chalk/index.css"
// import '@/styles/theme/index.css';    //设置主题色
import "./styles/element-variables.scss"
import "@/styles/index.scss" // 全局 css
import "@/icons" // icon
import "@/permission" // 路由权限控制
import Cookies from "js-cookie"
import "./directive/chart-resize.js"

// 设置英文
//locale.use(enLocale);
Vue.use(ElementUI, { size: Cookies.get("size") || "medium", zIndex: 3000 })
Vue.config.productionTip = false

import vueToPdf from "vue-to-pdf"
Vue.use(vueToPdf)
import Directives from "@/directive/index_tjtf" // 路由权限控制
Vue.use(Directives)
new Vue({
  router,
  store,
  i18n, //添加进vue实例中
  render: (h) => h(App)
}).$mount("#app")
